import { Moon, Sun } from 'lucide-react';
import { useTema } from '../../hooks/useTema';

/** Botón de tema de la cabecera (DESIGN.md §10): luna en modo claro, sol en modo oscuro. */
export default function ThemeToggle({ className = '' }: { className?: string }) {
  const [tema, alternar] = useTema();
  const oscuro = tema === 'oscuro';
  const rotulo = oscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro';
  return (
    <button
      type="button"
      onClick={alternar}
      aria-label={rotulo}
      title={rotulo}
      className={`w-9 h-9 inline-flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-50 hover:text-gray-700 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${className}`}
    >
      {oscuro ? <Sun className="w-5 h-5" aria-hidden="true" /> : <Moon className="w-5 h-5" aria-hidden="true" />}
    </button>
  );
}
